import { animate, style, transition, trigger } from "@angular/animations";
import { ChangeDetectorRef, Component, HostBinding, Injectable, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { TranslationService } from "@services/translation.service";
import "./loadingIndicator.component.scss";

export const defaultTransitionTime = "0.3s";

const styleFromState = style({ "opacity": '0', "pointer-events": "none" });
const styletoState = style({ "opacity": '1', "pointer-events": "all" });

export const fadeInOut = trigger("animFadeInOut", [
    transition(':enter', [
        styleFromState,
        animate(defaultTransitionTime, styletoState)
    ]),
    transition(':leave', [
        styletoState,
        animate(defaultTransitionTime, styleFromState)
    ])
]);

@Component({
    selector: "loading-indicator",
    template: `<div class="loading-indicator-container" [ngClass]="{'modal' : modal, 'slow' : slow}" *ngIf="showSpinner">
                    <div class="circle-spinner" *ngIf="!error"></div>
                    <div class="slow-loading-text">{{text}}</div>
                </div>`,
    animations: [fadeInOut]
})
export class LoadingIndicatorComponent implements OnInit, OnChanges {
    @HostBinding('@animFadeInOut') animateComponent() {
        return ":enter";
    }

    @Input() text: string;
    @Input() error: boolean;
    @Input() modal: boolean;
    @Input() supressSlowMessage: boolean;

    // ---

    slow: boolean;
    showSpinner: boolean;
    slowTimeout: number;

    // ---

    constructor(
        private cd: ChangeDetectorRef,
        private translationService: TranslationService) {
    }

    ngOnInit(): void {
        this.toggleSpinnerTimeout();
        this.toggleSlowTimeout();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["text"]) {
            this.text = this.text || this.translationService.t("loadingIndicator.stillWorking");
        }

        if (changes["error"] && this.error) {
            this.text = this.translationService.t("loadingIndicator.error");
        }
    }

    // --

    private toggleSpinnerTimeout() {
        this.showSpinner = false;

        setTimeout(() => {
            this.showSpinner = true;
            this.cd.markForCheck();
        }, 150);
    }

    private toggleSlowTimeout() {
        if (this.supressSlowMessage) {
            return;
        }

        if (!this.slowTimeout) {
            this.slowTimeout = window.setTimeout(() => { this.slow = true; }, 5000);
        }
        else {
            if (this.slowTimeout) {
                window.clearTimeout(this.slowTimeout);
                this.slowTimeout = null;
            }

            this.slow = false;
        }
    }
}
